export default __webpack_public_path__ + "static/media/form-otp-golden.bc326029.svg";